import { createContext } from "react";

export interface LoadingContextProps{
    setLoading: (isLoading: boolean) => void;
    loading: boolean;
}
const LoadingContext = createContext<LoadingContextProps>({
    setLoading: (message)=> console.log(message),
    loading: false
})

export default LoadingContext;